// src/components/PresenceProvider.jsx
import { useEffect } from "react";
import { db } from "../firebase";
import {
  collection,
  doc,
  setDoc,
  serverTimestamp,
  deleteDoc,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";

export default function PresenceProvider() {
  useEffect(() => {
    const auth = getAuth();
    const user = auth.currentUser;
    const sessionId = crypto.randomUUID(); // unique ID per browser tab
    const ref = doc(collection(db, "onlineUsers"), sessionId);

    // Initial presence document
    setDoc(ref, {
      uid: user?.uid || null,
      guest: !user,
      lastActive: serverTimestamp(),
    });

    // Heartbeat every 45s to keep "lastActive" fresh
    const interval = setInterval(() => {
      setDoc(
        ref,
        {
          uid: user?.uid || null,
          guest: !user,
          lastActive: serverTimestamp(),
        },
        { merge: true }
      );
    }, 45000);

    // Cleanup: delete the session doc when the tab closes
    const cleanup = () => deleteDoc(ref);
    window.addEventListener("beforeunload", cleanup);

    return () => {
      clearInterval(interval);
      cleanup();
      window.removeEventListener("beforeunload", cleanup);
    };
  }, []);

  return null; // No UI
}
